<template>
  <div id="app">

    <div class="container-fluid">
      <nav class="navbar navbar-expand-lg navbar-light bg-light mb-4">

        <!-- If user is logged in, link to their dashboard -->
        <router-link v-if="loggedIn" class="navbar-brand" :to="{ name: 'dashboard'}">
          <img class="img-fluid" alt="Vue logo" src="./assets/logo.png" style="width: 30px; height: 30px">
          Warboard Project Management
        </router-link>
        <!-- If user is not logged in, link to home -->
        <router-link v-else class="navbar-brand" :to="{ name: 'home'}">
          <img class="img-fluid" alt="Vue logo" src="./assets/logo.png" style="width: 30px; height: 30px">
          Warboard Project Management
        </router-link>

        <!-- Toggle Button -->
        <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
          <span class="navbar-toggler-icon"/>
        </button>

        <div class="collapse navbar-collapse" id="navbarSupportedContent">
          <!-- if logged in, display application links -->
          <div v-if="loggedIn" class="navbar-nav ml-auto">
            <router-link class="nav-item nav-link" :to="{ name: 'jobs'}">Jobs</router-link>
            <router-link class="nav-item nav-link" :to="{ name: 'project_journal'}">Project Journal</router-link>
            <router-link class="nav-item nav-link" :to="{ name: 'RFIs'}">RFI's</router-link>
            <router-link class="nav-item nav-link" :to="{ name: 'transmittals'}">Transmittals</router-link>
            <router-link class="nav-item nav-link" :to="{ name: 'TimeTracking'}">Time Tracking</router-link>
            <div class="nav-item dropdown">
              <a class="nav-link dropdown-toggle" href="#" id="navbarDropdown" role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                Account <font-awesome-icon icon="user"/>
              </a>
              <div class="dropdown-menu dropdown-menu-right" aria-labelledby="navbarDropdown">
                <a class="dropdown-item" href="#">Action</a>
                <a class="dropdown-item" href="#">Another action</a>
                <div class="dropdown-divider"></div>
                <router-link class="dropdown-item" :to="{ name: 'Logout'}">Logout</router-link>
              </div>
            </div>
          </div>
          <!-- Otherwise display guest links -->
          <div v-else class="navbar-nav ml-auto">
            <router-link class="nav-item nav-link" :to="{ name: 'login'}">Login</router-link>
          </div>
        </div>
      </nav>


      <transition name="fade" mode="out-in">
        <router-view class="mt-4"/>
      </transition>


    </div>

  </div>
</template>

<script>

export default {
  name: 'Warboard',
  computed: {
    currentUser() {
      return this.$store.getters.current_user
    },
    loggedIn() {
      return this.$store.getters.loggedIn;
    }
  },

}
</script>

<style lang="scss">


  .fade-enter-active, .fade-leave-active {
    transition: opacity .25s;
  }
  .fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
    opacity: 0;
  }
</style>
